export default "__VITE_ASSET__BEpukMyi__"